module.exports = __webpack_public_path__ + "static/media/logotitle.31c238d1.png";